import { defineFunctionIfMissing } from "./backport-utils";

/**
 * Polyfill for r72 THREE.Vector3
 *
 * Vector3 (r180): https://github.com/mrdoob/three.js/blob/r180/src/math/Vector3.js
 */
export const defineVector3 = (THREE) => {

  defineFunctionIfMissing(THREE?.Vector3?.prototype, "addScaledVector", function addScaledVector(v, s) {
    this.x += v.x * s;
    this.y += v.y * s;
    this.z += v.z * s;

    return this;
  });
};